import React, { useEffect } from "react";
import Footer from "../Footer/Footer";
import styled from "styled-components";
import HeaderNavImproved from "../Nav/HeaderNavImproved/HeaderNavImproved.tsx";
import { useLocation } from "react-router-dom";
import { useNavVisibility } from "../../hooks/useNavVisibility.ts";

const ContainerBig = styled.main`
  display: flex;
  position: relative;
  justify-content: center;
  background-color: #f8fafc;
  height: 100%;
  min-height: 100vh;
`;

const Container = styled.main`
  width: 100%;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
  transition: padding-left 0.5s ease-in-out;
  margin-top: 60px;

  @media (max-width: 900px) {
    padding-left: 0px;
    margin-top: 0px;
  }
`;



const Content = styled.main`
  width: 100%;
  height: 100%;
  min-height: ${(props) => (props.isDashboard ? "85vh" : "calc(100vh - 60px)")};
  margin: 0 auto;
  @media (max-width: 480px) {
    padding: 0;
    height: 100%;
  }
`;

const Layout = ({ children }) => {
  const { ocultarEnMobile } = useNavVisibility();
  const location = useLocation();

  const isDashboard = location.pathname === "/dashboard";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <ContainerBig>
      {!ocultarEnMobile && (
        <HeaderNavImproved />
      )}
      <Container>
        <Content>
          {children}
        </Content>
        {isDashboard && <Footer />}
      </Container>
    </ContainerBig>
  );
};

export default Layout;
